<div class="facebook-login">
    <button type="button" class="btn-ingresar btn btn-block facebook-btn" (click)="loginFacebook()">
        <fa name="facebook" *ngIf="showIcono" class="icono"></fa>
        &nbsp;Ingresar con Facebook
    </button>
</div>
